import { Box, Skeleton } from '@mui/material';
import { ChevronLeftIcon } from 'Components/designSystem';
import { useSetMobileHeader } from 'features/navigation';
import { memo } from 'react';
import { APP_ROUTES } from 'shared/constants';
import { useIsMobile } from 'shared/hooks';
import styled from 'styled-components';

import { offerPagePadding } from '../styles';

function OfferSkeleton() {
    const isMobile = useIsMobile();

    useSetMobileHeader({
        isLoading: true,
        backUrl: APP_ROUTES.candidateOffers,
        title: ''
    });

    return (
        <Container>
            { !isMobile && (
                <Box display="flex"
                    alignItems="center"
                    gap={ 4 }
                >
                    <ChevronLeftIcon />
                    <Skeleton width={ 100 } />
                </Box>
            )  }
            <Skeleton width={ 220 } />
            <Skeleton width={ 120 } />
            <Skeleton width={ 180 } />
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${ ({ theme }) => theme.size.size_20 };
    padding-top: ${ ({ theme }) => theme.size.size_30 };
    padding-bottom: ${ ({ theme }) => theme.size.size_30 };

    ${ offerPagePadding }
`;

export default memo(OfferSkeleton);
